import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class OlvidePasswordService {

  constructor(private _http: HttpClient) { }

  comprobarCorreo(email: string) {
    return this._http.get<boolean>(
      `${environment.API_URL}/ValidacionRegistroCorreo?Correo=` + email
    );
  }

  public forgotPassword(Email: any){
    return this._http.get<any>(`${environment.API_URL}/RecuperarPassword/Correo?Email=${Email}`);
  }
  // public forgotPassword(form: any){
  //   return this._http.post<any>(`${environment.API_URL}/RecuperarPassword/Correo`, form);
  // }
}
